import {computed} from 'mobx';
import {DashboardState, IMessageAlert} from '../../states/dashboard/_contracts/DashboardState';
import {ITsImageEditorController} from '../ts-image-editor/ts-image-editor.controller';
import {ITsImageEditToolsController} from '../ts-image-edit-tools/ts-image-edit-tools.controller';
import {MeetingMode} from '@techsee/techsee-common/lib/constants/room.constants';

export interface IVideoModeController {
    toggleMute: (event: React.MouseEvent) => void;
}

export interface ITsWidgetsController {
    readonly dashboardState: DashboardState;
    readonly handleDashboardTitleAction: (event: React.MouseEvent) => void;
    readonly displayAudioButton: boolean;
    readonly videoModeController: IVideoModeController;
    readonly mode: string;
    readonly endedTheMeeting: boolean;
    readonly imageEditToolsController: ITsImageEditToolsController;
    readonly returnToOneClickGuidance: boolean;
    readonly showDashboardTitle: boolean;
    readonly showMessageAlert: boolean;
    readonly showImageEditTools: boolean;
    readonly showImageWidget: boolean;
    readonly messageAlert: IMessageAlert | null;
    readonly imageEditorController: ITsImageEditorController;
    readonly displayLoaderReconnecting: boolean;
}

export class TsWidgetsController implements ITsWidgetsController {
    public readonly dashboardState: DashboardState;
    public readonly handleDashboardTitleAction: (event: React.MouseEvent) => void;
    public readonly videoModeController: IVideoModeController;
    public readonly mode: string;
    public readonly messageAlert: IMessageAlert | null;
    public readonly endedTheMeeting: boolean;
    public readonly imageEditToolsController: ITsImageEditToolsController;
    public readonly returnToOneClickGuidance: boolean;
    public readonly imageEditorController: ITsImageEditorController;

    constructor(
        dashboardState: DashboardState,
        handleDashboardTitleAction: (event: React.MouseEvent) => void,
        videoModeController: IVideoModeController,
        imageEditorController: ITsImageEditorController,
        imageEditToolsController: ITsImageEditToolsController
    ) {
        this.dashboardState = dashboardState;
        this.handleDashboardTitleAction = handleDashboardTitleAction;
        this.videoModeController = videoModeController;
        this.mode = this.dashboardState.clientRoomStorage.mode;
        this.messageAlert = this.dashboardState.messageAlert;
        this.endedTheMeeting = this.dashboardState.endedTheMeeting;
        this.imageEditToolsController = imageEditToolsController;
        this.imageEditorController = imageEditorController;
        this.returnToOneClickGuidance = this.dashboardState.returnToOneClickGuidance;
    }

    @computed
    get displayAudioButton(): boolean {
        return this.dashboardState.displayAudioButton;
    }

    @computed
    get displayLoaderReconnecting(): boolean {
        return this.dashboardState.displayLoaderReconnecting;
    }

    @computed
    get showImageWidget(): boolean {
        return this.dashboardState.showImageWidget;
    }

    @computed
    get showDashboardTitle(): boolean {
        return (
            !!this.dashboardState.currentResource?.url &&
            !(this.returnToOneClickGuidance && this.displayLoaderReconnecting)
        );
    }

    @computed
    get showMessageAlert(): boolean {
        return (
            this.mode !== MeetingMode.oneClick &&
            this.mode !== MeetingMode.images &&
            !!(this.messageAlert as IMessageAlert)?.display
        );
    }

    @computed
    get showImageEditTools(): boolean {
        return !this.endedTheMeeting && this.dashboardState.displayImageEditTools;
    }
}
